import {Box, Button, Dialog, DialogContent, Typography} from "@mui/material";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import kioskLogout from "../logout";

export default function KioskLogoutDialog({open, onClose, onStaffAccess}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogContent sx={{p: 4, textAlign: "center"}}>
        <LogoutRoundedIcon sx={{fontSize: 56, color: "error.main"}}/>
        <Typography sx={{fontSize: 26, fontWeight: 900, mt: 1}}>要登出這台機器嗎？</Typography>
        <Typography sx={{fontSize: 17, color: "text.secondary", mt: 1.5}}>登出後需要重新輸入 POS 帳號密碼才能繼續使用自助點餐。</Typography>
        <Box sx={{display: "grid", gap: 1.5, mt: 3}}>
          <Button color="error" variant="contained" onClick={kioskLogout} sx={{minHeight: 60, fontSize: 20}}>確定登出</Button>
          <Button variant="outlined" onClick={onClose} sx={{minHeight: 60, fontSize: 20}}>取消</Button>
          {onStaffAccess && <Button variant="text" onClick={onStaffAccess} sx={{fontSize: 16}}>店員維護</Button>}
        </Box>
      </DialogContent>
    </Dialog>
  );
}
